import { isDevBuild } from './isDevBuild';

export * from './isAndroidBuild';
export * from './isDevBuild';
export * from './isWebBuild';
export * from './isRobotUser';

/** Logs to console, only in development mode */
export const debugLog = (...params: Parameters<typeof console.log>) =>
  isDevBuild() ? console.log(...params) : undefined;
